module.exports = __webpack_public_path__ + "img/download.da4a80e5.svg";